<div class="dialog">
    <h2 mat-dialog-title class="header">
      <span class="title">{{ 'profile.profile_userinfo_label' | translate }}</span>
      <button class="close-ref" mat-icon-button (click)="close()" [title]="'general.close' | translate | titlecase">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div mat-dialog-content>
        <div class="user-content-form">
            <form [formGroup]="profileFormGroup">
                <div>
                    <!-- Email -->
                    <mat-form-field appearance="outline" class="size-s">
                        <mat-label>{{ "profile.email_label" | translate }}</mat-label>
                        <input
                            #email
                            matInput
                            formControlName="email"
                            [placeholder]="'profile.email_placeholder' | translate"
                        />
                    </mat-form-field>
                    <!-- Firstname -->
                    @if (isSubscribed) {
                        <mat-form-field appearance="outline" class="size-s">
                            <mat-label>{{ "profile.firstname_label" | translate }}</mat-label>
                            <input
                                #firstname
                                matInput
                                formControlName="firstname"
                                [placeholder]="'profile.firstname_placeholder' | translate"
                                required
                                maxlength="150"
                            />
                            <mat-error>{{
                            "profile.firstname_validation" | translate
                            }}</mat-error>
                        </mat-form-field>
                    }
                    <!-- Lastname -->
                    @if (isSubscribed) {
                        <mat-form-field appearance="outline" class="size-s">
                            <mat-label>{{ "profile.lastname_label" | translate }}</mat-label>
                            <input
                                #lastname
                                matInput
                                formControlName="lastname"
                                [placeholder]="'profile.lastname_placeholder' | translate"
                                required
                                maxlength="150"
                            />
                            <mat-error>{{ "profile.lastname_validation" | translate }}</mat-error>
                        </mat-form-field>
                    }
                    <!-- Birthday -->
                    <mat-form-field appearance="outline" class="size-s">
                        <mat-label>{{ "profile.birthday_label" | translate }}</mat-label>
                        <input
                            #birthday
                            matInput
                            type="date"
                            formControlName="birthday"
                            [placeholder]="'profile.birthday_placeholder' | translate"
                            required
                        />
                        <mat-error>{{ "profile.birthday_validation" | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-buttons-end">
      <button class="close-ref cancel" mat-flat-button color="primary" [title]="'general.cancel' | translate | titlecase" (click)="close()">
        {{ 'general.cancel' | translate}}
      </button>
      <button class="close-ref confirm" mat-flat-button color="accent" [disabled]="!profileFormGroup.dirty || updating" [title]="'general.save' | translate | titlecase" (click)="save()">
        {{ 'general.save' | translate }}
      </button>
    </div>
</div>